import http from "../../utils/httpClient";

class adsService {
  createOrUpdateAds = async (data) => {
    return await http
      .post("/api/Content/CreateAds", data)
  };

  getAds = async () => {
    return await http.get("/api/Content/GetContent");
  };

  createOrUpdateAdsType = async (data) => {
    return await http.post("/api/v2/Ads/AddOrEditAdsType", data)
  };

  getAdsType = async (query) => {
    return await http.get("/api/v2/Ads/GetAdsType", { params: query });
  };

  createOrUpdateAdsImageLocation = async (data) => {
    return await http.post("/api/v2/Ads/AddOrEditImageLocation", data)
  };
  
  getAdsImageLocation = async (query) => {
    return await http.get("/api/v2/Ads/GetImageLocation", { params: query });
  };

  createOrUpdateAdsImageType = async (data) => {
    return await http.post("/api/v2/Ads/AddOrEditImageType", data)
  };
  
  getAdsImageType = async (query) => {
    return await http.get("/api/v2/Ads/GetImageType", { params: query });
  };

  getAdBanner = async (query) => {
    return await http.get("/api/Content/GetContent", { params: query });
  };
}
export default new adsService();
